// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad00aec6","732":"11917456","821":"5a419cb5"}[chunkId] + ".chunk.js";
};